var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyFolder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.125 26.8594H22.5C19.3931 26.8594 16.875 29.3775 16.875 32.4844V43.7344H103.125V26.8594Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.125 23.6973C103.125 20.5904 100.607 18.0723 97.5 18.0723C89.5706 18.0723 75.2756 18.0723 68.1019 18.0723C65.4112 18.0723 62.925 19.5141 61.59 21.8504C59.3756 25.7279 56.25 31.1973 56.25 31.1973H103.125V23.6973Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 32.1328H103.125V35.6259H16.875V32.1328Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.439 42.955C109.738 40.8062 109.091 38.6331 107.668 36.9981C106.243 35.3612 104.18 34.4219 102.011 34.4219C82.8932 34.4219 37.1057 34.4219 17.9882 34.4219C15.8189 34.4219 13.7564 35.3612 12.3314 36.9981C10.9082 38.6331 10.2614 40.8062 10.5595 42.955C12.4607 56.6425 16.1507 83.2075 17.8514 95.455C18.367 99.1619 21.5357 101.922 25.2801 101.922H94.7189C98.4632 101.922 101.632 99.1619 102.148 95.455C103.848 83.2075 107.538 56.6425 109.439 42.955Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1895 47.4925C11.3301 45.9306 11.9564 44.4381 13.0045 43.2344C14.4276 41.5994 16.4901 40.66 18.6595 40.66H101.339C103.509 40.66 105.571 41.5994 106.994 43.2344C108.043 44.4381 108.669 45.9306 108.809 47.4925L109.439 42.955C109.738 40.8062 109.091 38.6331 107.668 36.9981C106.243 35.3612 104.18 34.4219 102.011 34.4219C82.8932 34.4219 37.1057 34.4219 17.9882 34.4219C15.8189 34.4219 13.7564 35.3612 12.3314 36.9981C10.9082 38.6331 10.2614 40.8062 10.5595 42.955L11.1895 47.4925Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5645 83.2227C51.5645 81.1527 49.8863 79.4727 47.8145 79.4727C43.6538 79.4727 36.977 79.4727 32.8145 79.4727C30.7445 79.4727 29.0645 81.1527 29.0645 83.2227V86.9727C29.0645 89.0445 30.7445 90.7227 32.8145 90.7227H47.8145C49.8863 90.7227 51.5645 89.0445 51.5645 86.9727C51.5645 85.767 51.5645 84.4302 51.5645 83.2227Z",
    fill: "#828282"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6875 47.998C68.8219 47.998 60 56.8199 60 67.6855C60 78.5512 68.8219 87.373 79.6875 87.373C90.5531 87.373 99.375 78.5512 99.375 67.6855C99.375 56.8199 90.5531 47.998 79.6875 47.998ZM79.6875 53.623C87.4481 53.623 93.75 59.9249 93.75 67.6855C93.75 75.4462 87.4481 81.748 79.6875 81.748C71.9269 81.748 65.625 75.4462 65.625 67.6855C65.625 59.9249 71.9269 53.623 79.6875 53.623Z",
    fill: "#828282"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9418 81.282L107.432 98.772C108.531 99.8707 110.312 99.8707 111.411 98.772C112.507 97.6751 112.507 95.892 111.411 94.7951L93.9205 77.3051C92.8218 76.2082 91.0405 76.2082 89.9418 77.3051C88.8449 78.402 88.8449 80.1851 89.9418 81.282Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder2);
export default __webpack_public_path__ + "static/media/empty-folder 2.6c15fe0b39bb99370c2b8a5e3293d032.svg";
export { ForwardRef as ReactComponent };